import {
  GetStorageItemsQueryVariables,
  useApolloClient,
} from '@sketch/gql-types'
import { readStorageItems } from '@sketch/modules-common'

// Generates a new folder name (New Folder, New Folder (2), etc), based on the
// existing folders
export const useGenerateFolderName = (
  storageItemsQueryVariables: GetStorageItemsQueryVariables,
  projectIdentifier?: string
) => {
  const cache = useApolloClient()

  const generateFolderName = () => {
    if (!projectIdentifier) return 'New Folder'

    const data = readStorageItems(cache, storageItemsQueryVariables)

    if (!data?.project?.storageItems) return 'New Folder'

    const storageItems = data.project.storageItems.entries
    const biggestFolderNumber = Object.values(storageItems)
      .filter(
        ({ name, __typename }) =>
          __typename === 'Project' && name.startsWith('New Folder')
      )
      .map(({ name }) => {
        const match = name.match(/^New Folder(?: (\d+))?$/)
        return match ? parseInt(match[1] || '1', 10) : NaN
      })
      .filter(number => !isNaN(number))
      .reduce((max, current) => Math.max(max, current), 0)

    return biggestFolderNumber === 0
      ? 'New Folder'
      : `New Folder (${biggestFolderNumber + 1})`
  }

  return generateFolderName
}
